import { BaseEntity } from './base';

export class Faq extends BaseEntity {
  question: string;
  answer: string;
}
